// removed by extract-text-webpack-plugin
module.exports = {"login":"antd-pro-login-login","icon":"antd-pro-login-icon","other":"antd-pro-login-other","register":"antd-pro-login-register","prefixIcon":"antd-pro-login-prefixIcon","submit":"antd-pro-login-submit"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/Login/index.less
// module id = 143
// module chunks = 0